import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    position: 'absolute',
    backgroundColor: theme?.confirmationPopup?.backdropBackgroundColor,
  },
  container: {
    backgroundColor: theme?.confirmationPopup?.backgroundColor,
    padding: theme.spacing(2),
    width: '80%',
    borderRadius: theme.spacing(0.6),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme?.confirmationPopup?.borderColor,
  },
  title: {
    marginBottom: theme.spacing(1.5),
    color: theme?.confirmationPopup?.titleColor,
  },
  bodyText: {
    minHeight: '80px',
    overflow: 'scroll',
    color: theme?.confirmationPopup?.textColor,
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: theme.spacing(1.5),
  },
  button: {
    borderWidth: 1,
    borderStyle: 'solid',
    width: '40%',
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  primaryButton: {
    backgroundColor: theme?.confirmationPopup?.primaryButtonBackgroundColor,
    color: theme?.confirmationPopup?.primaryButtonTextColor,
    borderColor: theme?.confirmationPopup?.primaryButtonBorderColor,
    '&:hover': {
      backgroundColor: theme?.confirmationPopup?.primaryButtonBackgroundColor,
    },
  },
  secondaryButton: {
    backgroundColor: theme?.confirmationPopup?.secondaryButtonBackgroundColor,
    color: theme?.confirmationPopup?.secondaryButtonTextColor,
    borderColor: theme?.confirmationPopup?.secondaryButtonBorderColor,
    '&:hover': {
      backgroundColor: theme?.confirmationPopup?.secondaryButtonBackgroundColor,
    },
  },
}));

export default useStyles;
